import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PageMeta from '../components/PageMeta';
import LeadForm from '../components/LeadForm';
import Reveal from '../components/Reveal';

const { FiPhone, FiMapPin, FiClock } = FiIcons;

function Contact() {
  return (
    <>
      <PageMeta title="Contact Cambia Digital" description="Talk with a vendor-neutral technology advisor serving NYC, Brooklyn, Queens, and the Tri-State area." />
      <section className="contact-page">
        <div className="contact-grid">
          <Reveal>
            <span className="eyebrow">Talk with an advisor</span>
            <h1>Start with the business problem—not a product demo.</h1>
            <p>Tell us what you’re evaluating, what is not working, or where costs feel out of control. We’ll help define the right next step.</p>
            <div className="contact-methods">
              <a href="tel:+17185550142"><SafeIcon icon={FiPhone} /><span><small>Call directly</small><strong>(718) 555-0142</strong></span></a>
              <div><SafeIcon icon={FiMapPin} /><span><small>Core service area</small><strong>NYC Tri-State, Brooklyn & Queens</strong><em>Approximately 50-mile radius; remote support available</em></span></div>
              <div><SafeIcon icon={FiClock} /><span><small>Business hours</small><strong>Monday–Friday, 9 AM–6 PM ET</strong></span></div>
            </div>
          </Reveal>
          <Reveal className="contact-form-card">
            <h2>How can we help?</h2>
            <LeadForm name="contact" />
          </Reveal>
        </div>
      </section>
    </>
  );
}

export default Contact;